<template>
  <div v-if="blok" class="mb-2">
    <button
      class="flex w-full items-center justify-between bg-gray-200 p-3 text-left text-gray-700"
      @click="toggleCollapse"
    >
      <span class="font-rubik text-lg font-medium">{{
        blok?.fields.title
      }}</span>
      <IconChevronDown
        class="size-6 transition-transform duration-200"
        :class="{ 'rotate-180': !isCollapsed }"
      />
    </button>
    <SFFadeInTransition>
      <div v-if="!isCollapsed" class="bg-transparent px-4 py-6">
        <CMSText v-if="blok.fields.body" :blok="blok.fields.body" />
      </div>
    </SFFadeInTransition>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import type { CMSAccordionEntryProps } from '../types'
import CMSText from './Text.vue'
import { SFFadeInTransition } from '#storefront-ui/components'

const { collapsed = false } = defineProps<CMSAccordionEntryProps>()

const isCollapsed = ref(collapsed)

function toggleCollapse() {
  isCollapsed.value = !isCollapsed.value
}

defineOptions({ name: 'CMSAccordionEntry' })
</script>
